// project import
import main from './main';
import makeAppointment from './makeAppointment';
import medCard from './medcard';
import myFamily from './myFamily';
import myAppointments from './myAppointments';
import fdoc from './fdoc';
import promotions from './promotions';
import contacts from './contacts';
import chatFeedBack from './chatFeedback';
import services from './services';
import payment from './payment';
import basket from './basket';
import admin from './admin';
import materials from './materials';

// config
import projectConfig from '@/projectConfig';

// ==============================|| MENU ITEMS ||============================== //

const feedbackPage = projectConfig.feedback ? chatFeedBack : null;

const menuItems = {
  items: [
      main, 
      makeAppointment, 
      medCard, 
      myFamily, 
      myAppointments, 
      fdoc, 
      promotions, 
      contacts, 
      chatFeedBack,
      services,
      payment,
      basket,
      admin,
      materials
    ]
};

// {
//   path: '/chatFeedback',
//   element: projectConfig.feedback ? <ChatFeedbackPage /> : <NotFoundPage/>
// },
// {
//   path: '/services',
//   element: projectConfig.payment ? <ServicesPage /> : <NotFoundPage/>
// },
// {
//   path: '/payment',
//   element: projectConfig.payment ? <PaymentPage /> : <NotFoundPage/>
// },
// {
//   path: '/basket',
//   element: projectConfig.payment ? <BasketPage /> : <NotFoundPage/>
// },

export default menuItems;
